export default {
  distance: {
    value: "{distance, number, distance} {unit}"
  },
  send_to_phone: {
    mail: {
      body: "{url}"
    }
  },
  directions: {
    travel_time: `\
{weeks, plural, =0 {} =1 {# wk} other {# wks}}
{days, plural, =0 {} =1 {# day} other {# days}}
{hours, plural, =0 {} =1 {# hr} other {# hrs}}
{minutes, plural, =0 {} =1 {# min} other {# mins}}\
`
  },
  locations: {
    distance: "{distance, number, distance} {unit}"
  },
  info_window: {
    opening_hours: {
      period: "{start, time, short} – {end, time, short}"
    },
    fuel_prices: {
      price: "{price, number, fuelPrice}",
      timestamp: "{timestamp, date, dateFormat}"
    }
  },
  fuels: {
    fuelsave_midgrade_gasoline: "Shell FuelSave Unleaded",
    fuelsave_regular_diesel: "Shell FuelSave Diesel",
    midgrade_gasoline: "Shell Regular",
    premium_diesel: "Shell V-Power Diesel",
    premium_gasoline: "Shell V-Power",
    shell_regular_diesel: "Shell Diesoline Ultra",
    super98: "Shell Super Premium",
    super_premium_gasoline: "Shell V-Power Racing",
    unleaded_super: "Shell Super Unleaded",
    kerosene: "Shell Kerosene"
  },
  amenities: {
    euroshell_card: "Shell Card",
    quick_lubes: "Oil Change Service",
    service_bay: "Helix Service Center",
    shell_card: "Shell Card",
    shop: "Convenience Store"
  }
}
